module.exports = __webpack_public_path__ + "img/icon-shopping-car.46e08401.svg";